import { takeEvery, call, put, all } from 'redux-saga/effects';
import { GET_FAMILY_DATA, ADD_FAMILY_DATA, REMOVE_FAMILY_DATA, UPDATE_FAMILY_DATA } from 'store/actionTypes';
import { GetCollectionDocs } from 'store/services/collection';
import { SetDocService, GetDocService, RemoveDocService } from 'store/services/document';
import { FileUploadService, FileRemoveService } from 'store/services/file';
import { message } from 'antd';

// watchers

export function* GetFamilyDataWatcher() {
  yield takeEvery(GET_FAMILY_DATA.WATCH, GetFamilyDataWorker);
}

export function* AddFamilyDataWatcher() {
  yield takeEvery(ADD_FAMILY_DATA.WATCH, AddFamilyDataWorker);
}

export function* UpdateFamilyDataWatcher() {
  yield takeEvery(UPDATE_FAMILY_DATA.WATCH, UpdateFamilyDataWorker);
}

export function* RemoveFamilyDataWatcher() {
  yield takeEvery(REMOVE_FAMILY_DATA.WATCH, RemoveFamilyDataWorker);
}

function* GetFamilyDataWorker({ payload }) {
  try {
    yield put({ type: GET_FAMILY_DATA.LOAD });
    const response = yield call(GetCollectionDocs, payload);
    yield put({ type: GET_FAMILY_DATA.SUCCESS, payload: response });
  } catch (e) {
    message.error(e.message);
    yield put({ type: GET_FAMILY_DATA.FAIL, payload: e.message });
  }
}


function* AddFamilyDataWorker({ payload }) {
  const { ref, data, files, collection, document } = payload;
  try {
    yield put({ type: ADD_FAMILY_DATA.LOAD });
    // upload files
    const imagesResponse = yield call(FileUploadService, payload.data);
    const iconResponse = yield call(FileUploadService, { ...payload.data, files: payload.data.icon });
    const updatedData = { collection, document, data: { ...data, icon: iconResponse[0], files: imagesResponse } };
    yield call(SetDocService, updatedData);
    yield put({ type: ADD_FAMILY_DATA.SUCCESS, payload: updatedData.data });
    payload.cb && payload.cb();
    message.success(`Пункт добавлен`);
  } catch (e) {
    message.error(e.message);
    yield put({ type: ADD_FAMILY_DATA.FAIL, payload: e.message });
  }
}

function* UpdateFamilyDataWorker({ payload }) {
  const { data } = payload;
  const { files, icon } = data;
  try {
    yield put({ type: UPDATE_FAMILY_DATA.LOAD });
    // check files that need to update
    const filesToUpload = [];
    const filesToNotUpload = [];
    files.map(it => typeof it !== 'string' ? filesToUpload.push(it) : filesToNotUpload.push(it));
    // uploaded files
    const uploadedFiles = yield call(FileUploadService, { files: filesToUpload, ref: data.ref });
    // //
    const iconResponse = typeof icon[0] !== 'string' ? yield call(FileUploadService, { files: icon, ref: data.ref }) : icon;
    const updatedData = {
      ...data,
      files: [...filesToNotUpload, ...uploadedFiles],
      icon: iconResponse[0],
    };
    yield call(SetDocService, { ...payload, data: updatedData });
    yield put({ type: UPDATE_FAMILY_DATA.SUCCESS, payload: updatedData });
    payload.cb && payload.cb();
    message.success(`Пункт обновлён`);
  } catch (e) {
    message.error(e.message);
    yield put({ type: UPDATE_FAMILY_DATA.FAIL, payload: e.message });
  }
}

function* RemoveFamilyDataWorker({ payload }) {
  const { item } = payload;
  try {
    yield put({ type: REMOVE_FAMILY_DATA.LOAD });
    const filesToRemove = [
      ...item.files.map(file => call(FileRemoveService, { ref: file })),
      call(FileRemoveService, { ref: item.icon })
    ];
    yield all(filesToRemove);
    yield call(RemoveDocService, payload);
    yield put({ type: REMOVE_FAMILY_DATA.SUCCESS, payload: payload.document });
    message.success(`Пункт удален`);

  } catch (e) {
    message.error(e.message);
    yield put({ type: REMOVE_FAMILY_DATA.FAIL, payload: e.message });
  }
}
